<template>
	<div id="new-client">
				<b-card no-body class="overflow-hidden margin-left" style="max-width: 540px;margin-left:30%;">
					<b-row no-gutters>
							<b-card-body title="Novo cliente">
									<ul>
										<li v-for="(error, index) in errors.all()" :key="index">{{ error }}</li>
									</ul>
									<b-input-group prepend="Nome" class="mt-3">
				<b-form-input
					v-model="client.name"
					v-validate="'required|alpha'"
					type="text"
					name="nome novo cliente"
				/>
									</b-input-group>
									<b-input-group prepend="Email" size="sm" class="mt-4">
				<b-form-input
					v-model="client.email"
					v-validate="'required|email'"
					type="email"
					name="email novo cliente"
				/>
									</b-input-group>
									<br>
		<b-button variant="primary" @click="signup()">criar novo</b-button>
							</b-card-body>
					</b-row>
				</b-card>
	</div>
</template>

<script>
import api from "../../api"
import generateBime from "../../utils/passwordGen"
import { mapMutations } from 'vuex';
export default {
	name: "newClient",
	data() {
		return {
			client: {
				email: "",
				name: ""
			},
			msgPwd: ""
		}
	},
	computed: {
		isNotLoggedIn() {
			return true
		}
	},
	methods: {
    ...mapMutations(['showNotice']),
		signup: function() {
			this.msgPwd = generateBime()
			api.signup(this.client.email, this.client.name, this.msgPwd).then(() => {
				this.showNotice({newMessage:" Client criado com password : " + this.msgPwd, type: "success", timer: 600})
			})
		}
	}
}
</script>

<style lang='css'>
#new-client {
  color: #53574D;
}
</style>
